import useAuth, { AuthMode } from "@/context/auth-provider";
import { lowerCaseComparison } from "@/lib/string-util";
import { useMemo } from "react";

const useGuestCheckSinglePage = () => {
  const { authData } = useAuth();
  const restrictPage = useMemo(() => {
    return (
      lowerCaseComparison(authData?.mode, AuthMode.GUEST) &&
      authData?.user?.route !== "home"
    );
  }, [authData]);
  const showSmartphone = useMemo(() => {
    return (
      lowerCaseComparison(authData?.mode, AuthMode.GUEST) &&
      authData?.user?.route === "home"
    );
  }, [authData]);

  return { restrictPage, showSmartphone };
};
export default useGuestCheckSinglePage;
